// Direct function refs — set by TutorialSwiper, called by any modal
type ControlFn = () => void;

let _pause: ControlFn = () => {};
let _resume: ControlFn = () => {};

export const registerSwiperControls = (pause: ControlFn, resume: ControlFn) => {
  _pause = pause;
  _resume = resume;
};

export const pauseSwiper = () => _pause();
export const resumeSwiper = () => _resume();
